import { ExchangeToken } from './ExchangeToken';

const ERROR_REQUEST_FAILED = 'Error: Token exchange request failed to obtain new access token.';

export async function triggerTokenExchange(targetClientId?: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const tokenExchangeCallback = (accessToken: string): void => {
            if (!accessToken) {
                reject(new Error(ERROR_REQUEST_FAILED));
            }

            resolve(accessToken);
        };

        ExchangeToken.exchangeToken(targetClientId, tokenExchangeCallback);
    });
}
